<div id="map-canvas"></div>
<div id="my-context-menu">
    <ul>
        <li><a (click) = "directionsFromHere($event)" (keyup.enter)="directionsFromHere($event)" tabindex="0">Directions from here</a></li>
        <li><a (click) = "directionsToHere($event)" (keyup.enter)="directionsToHere($event)" tabindex="0">Directions to here</a></li>
        <li><a (click) = "directionsViaHere($event)" (keyup.enter)="directionsViaHere($event)" tabindex="0">Via here</a></li>
        <hr>
        <li><a (click) = "directionsCenterHere($event)" (keyup.enter)="directionsCenterHere($event)" tabindex="0">Centre map here</a></li>
    </ul>
</div>